import * as yup from 'yup';

export const visaInitialValues = {
  visaCost: null,
  visaComments: '',
};

export const visaValidationSchema = yup.object().shape({
  visaCost: yup
    .number()
    .nullable()
    .transform((_, val) => (val === '' ? null : Number(val)))
    .required('Costs is required.')
    .typeError('Costs must be a number')
    .moreThan(0, 'Costs must be greater than 0'),
  visaComments: yup.string(),
});
